import $ from 'jquery';
import { AJAX_URL } from './config';
import { scrollToElement } from './lib/utilities';

$(() => {
  // Check if rating modal should be shown
  const showRatingModal = $('section.single-recipe').data('show-rating-modal');
  const ratingCookie = $('section.single-recipe').data('rating-cookie');
  if (
    showRatingModal === 'show-modal' &&
    document.cookie.indexOf(ratingCookie) === -1
  ) {
    // Show rating modal after 60 seconds
    setTimeout(() => {
      // Set cookie for 30 days
      const date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      document.cookie = `${ratingCookie}=true; expires=${date.toUTCString()}; path=/`;

      // add enctype="multipart/form-data" to form
      $('.modal--rating form').attr('enctype', 'multipart/form-data');

      $('.modal--rating').trigger('modal:show');
    }, 60000);
  }

  // if first rating, scroll to rate
  if ($('.ratings-count--first').length > 0) {
    $('.ratings-count, .card__rating').hide();

    $('.ratings-count--first').on('click', function () {
      scrollToElement($('#reply-title'));
    });
  } else {
    $('.ratings-count').on('click', function () {
      scrollToElement($('#reply-title'));
    });
  }

  let $rating = $(
    '.comment-respond .comments__recipe-rating .card__rating button'
  );

  $rating.on('click', function () {
    $rating = $(this);
    const { rating, disabled } = $rating.data();
    const data = {
      rating,
      disabled
    };

    userRating();

    function userRating() {
      const $newRatingStarsRed = $rating.prevAll().addBack();
      const $newRatingStarsGray = $rating.nextAll();

      $newRatingStarsRed.children('i').removeClass().addClass('icon-star-red');

      $newRatingStarsGray
        .children('i')
        .removeClass()
        .addClass('icon-star-gray');

      $rating.parents($('.rating-value').val(data.rating));
    }
  });

  const $commentForm = $('#commentform');
  const $commentText = $('#comment');

  // add enctype="multipart/form-data" to form
  $commentForm.attr('enctype', 'multipart/form-data');

  $commentForm.on('submit', function (event) {
    if ($commentText.val() === '') {
      $commentText.val('N/A');
    }

    return true;
  });
});

// after page load
$(window).on('load', function () {});
